export const getSessionStorageObjectItem = (key, fallbackValue = {}) => {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || fallbackValue;
  } catch {
    return fallbackValue;
  }
};
